import styled from 'styled-components/macro'
import { motion } from 'framer-motion'


export const mobileVariants = {
    initial: {
        opacity: 0
    },
    animate: {
       opacity: 1
    },
    exit: {
        opacity: 0,
        transition: {
            duration: .1
        }
    }
}

export const MobileContainer = styled(motion.div)`
    width: 100%;
    min-heigh: 32rem;
    display: none;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    position: relative;
    margin-top: 3rem;

    @media all and (max-width: 1024px) {
        display: flex;
    }
`

export const MobileTitle = styled(motion.h2)`
    margin: 0 1rem 0 1rem;
    text-align: center;
    color: white;
`

export const MobileInner = styled(motion.div)`
    width: 90%;
    height: 25rem;
    margin: 2rem auto 0 auto;
    display: flex;
    justify-content: center;

    @media all and (max-width: 650px) {
        margin-left: 10%;
    }
`

export const MobileListViewer = styled.div`
    width: 90%;
    height: 25rem;
`

// export const MobileContent = styled(motion.div)`
//     display: none;

//     @media all and (max-width: 650px) {
//         display: block;
//     }
// `

// export const Slider = styled(motion.div)`
//     display: none;
//     overflow: hidden;

//     @media all and (max-width: 650px) {
//         display: block;
//     }
// `

// export const InnerSlider = styled(motion.div)`
//     display: flex;
// `
